/** Aligned with StoreManagement / Kitchen-FrontEnd-UI design tokens */
export const MARKETING_LEAD_SEARCH_DEBOUNCE_MS = 650;

export const COLORS = {
  ink: '#111111',
  accentOrange: '#111111',
  labelFocusOrange: '#333333',
  muted: '#8C8C8C',
  border: '#E8E8E8',
  rowDivider: '#F0F0F0',
  headerBg: '#FAFAFA',
  pageBg: '#F5F4F2',
  white: '#FFFFFF',
};

export const outlinedInputSx = {
  '& .MuiInputLabel-root': {
    color: COLORS.ink,
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: 'Inter Regular, sans-serif',
  },
  '& .MuiInputLabel-root.Mui-focused': { color: COLORS.ink },
  '& .MuiInputLabel-root.MuiInputLabel-shrink': {
    color: COLORS.ink,
    fontWeight: 500,
    paddingLeft: '4px',
  },
  '& .MuiOutlinedInput-root': {
    height: '42px',
    borderRadius: '5px',
    bgcolor: COLORS.white,
    fontFamily: 'Inter Regular, sans-serif',
    fontSize: 13,
    transition: 'all 0.2s ease',
    '& fieldset': { borderColor: COLORS.border, borderWidth: '1px' },
    '&:hover fieldset': { borderColor: COLORS.ink },
    '&.Mui-focused fieldset': { borderColor: COLORS.ink, borderWidth: '1px' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: `${COLORS.ink} !important`,
    },
    '& input': { fontSize: '13px' },
  },
};

export const headerCellSx = {
  fontFamily: 'Inter Bold, sans-serif',
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: COLORS.muted,
  bgcolor: COLORS.headerBg,
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  borderBottom: `2px solid ${COLORS.border}`,
  py: 1.5,
  px: 2,
  whiteSpace: 'nowrap',
};

export const bodyCellSx = {
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  borderBottom: `1px solid ${COLORS.rowDivider}`,
  py: 1.5,
  px: 2,
  verticalAlign: 'middle',
  fontFamily: 'Inter Regular, sans-serif',
  fontSize: 13,
  color: COLORS.ink,
};
